import React, {useState} from "react";
import { CanDoForYouCard } from "../can-do-for-you-card/card";
import { useStyles } from "./style";
import { CanDoForYouProps } from "./types";
import classNames from "classnames";

export const CanDoForYou = (props: CanDoForYouProps) => {

    const classes = useStyles()
    const [hiddenItem, showHiddenItem] = useState(false);

    const loadMore = () => {
        showHiddenItem(
            true
        );
    };

    return (
        <section className={classes.canDoFoYouContainer}>
            <div className={"h1 " + classes.canDoFoYouTitle}>{props.title}</div>
            <div className={classes.canDoFoYouCardsContainer}>
                {props.cards.map((el, idx) => (
                    <div
                        key={idx}
                        className={
                            classNames(
                                classes.canDoFoYouCardItem,
                                { [classes.hidden]: idx >= 4 && !hiddenItem }
                            )
                        }
                    >
                    <CanDoForYouCard {...el} />
                    </div>
                ))}
                {!hiddenItem &&
                    <button className={classes.canDoFoYouLoadMore} onClick={loadMore}>
                        {props.buttonText ? props.buttonText : "See more"}
                    </button>
                }
            </div>
            {props.logos &&
                <div className={classes.canDoFoYouLogosWrapper}>
                    {props.logosTitle && <div className={"h2 " + classes.canDoFoYouLogosTitle}>{props.logosTitle}</div>}
                    {props.logosSubTitle && <div className={classes.canDoFoYouLogosSubTitle}>{props.logosSubTitle}</div>}
                    {props.logos && props.logos.length > 0 &&
                        <div className={classes.canDoFoYouLogosItems}>
                            {props.logos?.map((el, idx) => (
                                <a
                                    href={el.href}
                                    aria-label="Can do for you"
                                    key={idx}
                                    className={
                                        classNames(
                                            classes.canDoFoYouLogosItem,
                                            {
                                                [classes.canDoFoYouLogosItemLg]: el.size === "lg"
                                            }
                                        )
                                    }
                                >
                                    {el.img}
                                </a>
                            ))}
                        </div>
                    }
                </div>
            }
        </section>
    );
};
